import { useCallback } from "react";

import { fireLeadSubmitEvents } from "goi_common";

import { postLeadV2, PostLeadV2Body } from "@/apis/postLeadV2";

/**
 * v2 통합 리드 제출 진입점. HTTP(postLeadV2)와 집계 이벤트(fireLeadSubmitEvents)를 조립한다.
 *
 * 리드 폼은 이 훅을 쓴다. `postLeadV2` 를 직접 부르면 lead_submit 집계가 빠진다
 * (견적에서 호출부에 이벤트를 맡겨 11곳 중 9곳이 누락된 #2247 과 같은 실패).
 * `scripts/check-lead-submit-event.mjs` 가 직접 호출을 검사한다.
 *
 * API + 분석 조립을 훅에 두는 건 견적의 `useSangjoQuotationRequests` 와 같은 관례다.
 * 지금은 상태가 없어 순수 함수지만, isLoading 이 필요해지면 여기서 흡수한다
 * (호출부 대부분이 자체 loading state 를 갖고 있어 현재는 넣지 않음).
 */
export const useSubmitLead = () => {
  /** 호출부 useCallback deps 에 넣어도 재생성되지 않도록 참조를 고정한다. */
  const submitLead = useCallback(async (body: PostLeadV2Body) => {
    const data = await postLeadV2(body);
    fireLeadSubmitEvents(body.lead_type, body.status);
    return data;
  }, []);

  return { submitLead };
};
